function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { v4 as Z } from "uuid";
function bt() {
  return Z();
}
function Ft(_ref) {
  var t = _ref.wallets;
  if (t.length === 0) throw new Error("wallets prop is empty. Please provide at least one wallet.");
}
function Yt(_ref2) {
  var t = _ref2.nft;
  if (t == null) throw new Error("nft prop is empty. Please provide a valid nft.");
}
var tt = ["ethereum", "polygon", "bsc"],
  Vt = ["solana", "cardano"].concat(tt),
  et = function (o) {
    return o.reactUi = "client-sdk-react-ui", o.vanillaUi = "client-sdk-vanilla-ui", o;
  }(et || {}),
  nt = function (r) {
    return r.prod = "https://www.crossmint.com", r.staging = "https://staging.crossmint.com", r.dev = "http://localhost:3001", r;
  }(nt || {}),
  rt = function (o) {
    return o.clientVersion = "X-Client-Version", o.clientName = "X-Client-Name", o;
  }(rt || {}),
  Jt = function Jt(t) {
    return t === "ETH";
  },
  Xt = function Xt(t) {
    return t === "SOL";
  },
  ot = function (r) {
    return r.CANDY_MACHINE = "candy-machine", r.SOLANA_AUCTION = "solana-auction", r.ERC_721 = "erc-721", r;
  }(ot || {}),
  it = function (n) {
    return n.WAITING_SUBMISSION = "waiting-submission", n.PENDING = "pending", n.REJECTED = "rejected", n.ACCEPTED = "accepted", n.INVALID = "invalid", n;
  }(it || {});
var d = function d() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var e = ["prod", "production"];
  return t === "staging" ? "https://staging.crossmint.com" : e.includes(t) || !t ? "https://www.crossmint.com" : t;
};
function st(t) {
  if (typeof t == "string") return t;
  switch (t.chain) {
    case "solana":
      return "".concat(t.chain, ":").concat(t.mintHash);
    case "polygon":
    case "ethereum":
    case "bsc":
      return "".concat(t.chain, ":").concat(t.contractAddress, ":").concat(t.tokenId);
    case "cardano":
      return "".concat(t.chain, ":").concat(t.assetId);
    default:
      throw new Error("Invalid chain type ".concat(JSON.stringify(t)));
  }
}
function jt(t, e) {
  var o = d(t.environment),
    r = t.wallets,
    c = JSON.stringify(r),
    n = new URLSearchParams(_objectSpread({
      wallets: c,
      clientVersion: e
    }, t.uiConfig != null ? {
      uiConfig: JSON.stringify(t.uiConfig)
    } : {}));
  return "".concat(o, "/sdk/wallets/collection?").concat(n.toString());
}
function Kt(t, e) {
  var o = d(t.environment),
    r = new URLSearchParams(_objectSpread({
      clientVersion: e
    }, t.uiConfig != null ? {
      uiConfig: JSON.stringify(t.uiConfig)
    } : {})),
    c = st(t.nft);
  return "".concat(o, "/sdk/wallets/tokens/").concat(c, "?").concat(r.toString());
}
var zt = {
  CREDIT_CARD: "credit-card",
  GOOGLE_PAY: "google-pay",
  APPLE_PAY: "apple-pay"
};
var B = {
    PAYMENT_PREPARATION_FAILED: "payment:preparation.failed",
    PAYMENT_PROCESS_CANCELED: "payment:process.canceled",
    PAYMENT_PROCESS_REJECTED: "payment:process.rejected"
  },
  at = _objectSpread({
    PAYMENT_PREPARATION_SUCCEEDED: "payment:preparation.succeeded",
    PAYMENT_PROCESS_STARTED: "payment:process.started",
    PAYMENT_PROCESS_SUCCEEDED: "payment:process.succeeded"
  }, B),
  ct = {
    ORDER_PROCESS_STARTED: "order:process.started",
    ORDER_PROCESS_FINISHED: "order:process.finished"
  },
  Et = {
    QUOTE_STATUS_CHANGED: "quote:status.changed",
    QUOTE_STATUS_INVALIDATED: "quote:status.invalidated"
  },
  ut = {
    RECIPIENT_WALLET_CHANGED: "recipient:wallet.changed"
  },
  k = {
    TRANSACTION_FULFILLMENT_FAILED: "transaction:fulfillment.failed"
  },
  mt = _objectSpread({
    TRANSACTION_FULFILLMENT_SUCCEEDED: "transaction:fulfillment.succeeded"
  }, k),
  Zt = _objectSpread(_objectSpread({}, B), k),
  N = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, at), ct), Et), ut), mt),
  x = {
    PARAMS_UPDATE: "params-update"
  },
  M = {
    UI_HEIGHT_CHANGED: "ui:height.changed"
  };
var pt = {
    MINT_CONFIG_INVALID: "payments:mint-config.invalid",
    PAYMENT_METHOD_INVALID: "payments:payment-method.invalid",
    EMAIL_INVALID: "payments:email.invalid",
    CLIENT_ID_INVALID: "payments:client-id.invalid",
    MINTING_CONTRACT_MISSING: "payments:minting-contract.missing",
    COLLECTION_DISABLED: "payments:collection.disabled",
    COLLECTION_UNAVAILABLE: "payments:collection.unavailable",
    COLLECTION_UNVERIFIED: "payments:collection.unverified",
    PROJECT_UNVERIFIED: "payments:project.unverified",
    COLLECTION_SOLD_OUT: "payments:collection.sold-out",
    COLLECTION_NOT_LIVE: "payments:collection.not-live",
    COLLECTION_SALE_ENDED: "payments:collection.sale-ended",
    USER_WALLET_LIMIT_REACHED: "payments:user-wallet.limit-reached",
    USER_WALLET_NOT_WHITELISTED: "payments:user-wallet.not-whitelisted",
    PAYMENT_REJECTED_GENERIC_DECLINE: "payments:payment-rejected.generic-decline",
    PAYMENT_REJECTED_INSUFFICIENT_FUNDS: "payments:payment-rejected.insufficient-funds",
    PAYMENT_REJECTED_CARD_LOST: "payments:payment-rejected.card-lost",
    PAYMENT_REJECTED_CARD_STOLEN: "payments:payment-rejected.card-stolen",
    PAYMENT_REJECTED_CARD_EXPIRED: "payments:payment-rejected.card-expired",
    PAYMENT_REJECTED_CARD_INCORRECT_CVC: "payments:payment-rejected.card-incorrect-cvc",
    PAYMENT_REJECTED_PROCESSING_ERROR: "payments:payment-rejected.processing-error",
    PAYMENT_REJECTED_CARD_INCORRECT_NUMBER: "payments:payment-rejected.card-incorrect-number",
    TRANSACTION_ERROR_GENERIC: "payments:transaction-error.generic",
    CONTRACT_EXECUTION_REVERTED_GENERIC: "payments:contract-execution-reverted.generic"
  },
  ee = _objectSpread({}, pt);
var w = "__crossmint-overlay__",
  lt = 400,
  dt = 750,
  Ct = function Ct() {
    var t = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
    return t ? parseInt(t[2]) : null;
  };
function It(t, e) {
  function o() {
    return (window == null ? void 0 : window.top) != null ? window.top.outerWidth / 2 + window.top.screenX - t / 2 : window.outerWidth / 2 + window.screenX - t / 2;
  }
  function r() {
    return (window == null ? void 0 : window.top) != null ? window.top.outerHeight / 2 + window.top.screenY - e / 2 : window.outerHeight / 2 + window.screenY - e / 2;
  }
  var c = Ct();
  return "".concat(c && c > 99 ? "popup=true," : "", "height=").concat(e, ",width=").concat(t, ",left=").concat(o(), ",top=").concat(r(), ",resizable=yes,scrollbars=yes,toolbar=yes,menubar=true,location=no,directories=no, status=yes");
}
var Tt = function Tt(t) {
    var e = document.createElement("div");
    e.setAttribute("id", w);
    var o = {
      width: "100vw",
      height: "100vh",
      "background-color": "rgba(0, 0, 0, 0.5)",
      position: "fixed",
      "z-index": "99999999",
      top: "0",
      left: "0"
    };
    Object.assign(e.style, o), document.body.appendChild(e), t && e.addEventListener("click", function () {
      H();
    });
  },
  H = function H() {
    var t = document.getElementById(w);
    t && t.remove();
  };
function oe(_ref3) {
  var t = _ref3.clientId,
    e = _ref3.libVersion,
    o = _ref3.showOverlay,
    r = _ref3.dismissOverlayOnClick,
    c = _ref3.setConnecting,
    n = _ref3.environment,
    m = _ref3.clientName,
    u = _ref3.locale,
    p = _ref3.currency,
    f = _ref3.successCallbackURL,
    C = _ref3.failureCallbackURL;
  var E = function E(P, y, S, g, v, h, _, D) {
      var L = d(n),
        q = encodeURIComponent("".concat(L, "/checkout/mint?").concat(function () {
          var T = {
            clientId: t,
            clientName: m,
            clientVersion: e,
            mintConfig: JSON.stringify(P),
            locale: u,
            currency: p.toLowerCase()
          };
          return y && (T.mintTo = y), S && (T.emailTo = S), g && (T.listingId = g), v && (T.whPassThroughArgs = JSON.stringify(v)), h && (T.paymentMethod = h.toLowerCase()), _ && (T.preferredSigninMethod = _), D && (T.prepay = "true"), f && (T.successCallbackURL = f), C && (T.failureCallbackURL = C), new URLSearchParams(T).toString();
        }())),
        O = "".concat(L, "/signin?callbackUrl=").concat(q, "&locale=").concat(u, "&currency=").concat(p.toLowerCase()),
        U = window.open(O, "popUpWindow", It(lt, dt));
      if (U) {
        l(U), o && Tt(r);
        return;
      }
      c(!1), window.open(O, "_blank") || console.error("Failed to open popup window and new tab");
    },
    a = function a(P, y, S, g, v, h, _, D) {
      c(!0), E(P, y, S, g, v, h, _, D);
    };
  function l(P) {
    function y(g) {
      g.origin, d(n);
    }
    var S = setInterval(function () {
      P.closed && (clearInterval(S), c(!1), o && H(), window.removeEventListener("message", y));
    }, 500);
    window.addEventListener("message", y);
  }
  return {
    connect: a
  };
}
var ft = {
    crossmintPayButtonService: {
      CONNECTING: "\u8FDE\u63A5\u4E2D...",
      BUY_WITH_ETH: "\u4F7F\u7528ETH\u8D2D\u4E70",
      BUY_WITH_SOL: "\u4F7F\u7528SOL\u8D2D\u4E70",
      BUY_WITH_CREDIT_CARD: "\u4F7F\u7528\u4FE1\u7528\u5361\u8D2D\u4E70"
    },
    crossmintStatusButtonService: {
      INVALID: "\u65E0\u6548\u7684clientId",
      WAITING_SUBMISSION: "\u70B9\u51FB\u6B64\u5904\u8BBE\u7F6ECrossmint",
      PENDING: "\u60A8\u7684\u7533\u8BF7\u6B63\u5728\u5BA1\u67E5\u4E2D",
      ACCEPTED: "\u60A8\u5DF2\u51C6\u5907\u5C31\u7EEA\uFF01",
      REJECTED: "\u60A8\u7684\u7533\u8BF7\u5DF2\u88AB\u62D2\u7EDD"
    }
  },
  b = ft;
var yt = {
    crossmintPayButtonService: {
      CONNECTING: "Connessione...",
      BUY_WITH_ETH: "Acquista con ETH",
      BUY_WITH_SOL: "Acquista con SOL",
      BUY_WITH_CREDIT_CARD: "Acquista con carta di credito"
    },
    crossmintStatusButtonService: {
      INVALID: "clientId non valido",
      WAITING_SUBMISSION: "Clicca qui per configurare Crossmint",
      PENDING: "La tua richiesta \xE8 in fase di revisione",
      ACCEPTED: "Sei pronto per iniziare!",
      REJECTED: "La tua richiesta \xE8 stata respinta"
    }
  },
  W = yt;
var St = {
    crossmintPayButtonService: {
      CONNECTING: "Connecting...",
      BUY_WITH_ETH: "Buy with ETH",
      BUY_WITH_SOL: "Buy with SOL",
      BUY_WITH_CREDIT_CARD: "Buy with credit card"
    },
    crossmintStatusButtonService: {
      INVALID: "Invalid clientId",
      WAITING_SUBMISSION: "Click here to setup Crossmint",
      PENDING: "Your application is under review",
      ACCEPTED: "You're good to go!",
      REJECTED: "Your application was rejected"
    }
  },
  A = St;
var gt = {
    crossmintPayButtonService: {
      CONNECTING: "Connexion...",
      BUY_WITH_ETH: "Acheter avec ETH",
      BUY_WITH_SOL: "Acheter avec SOL",
      BUY_WITH_CREDIT_CARD: "Acheter avec une carte de cr\xE9dit"
    },
    crossmintStatusButtonService: {
      INVALID: "clientId invalide",
      WAITING_SUBMISSION: "Cliquez ici pour configurer Crossmint",
      PENDING: "Votre demande est en cours d'examen",
      ACCEPTED: "Vous \xEAtes pr\xEAt \xE0 partir !",
      REJECTED: "Votre demande a \xE9t\xE9 refus\xE9e"
    }
  },
  F = gt;
var Nt = {
    crossmintPayButtonService: {
      CONNECTING: "\u9023\u63A5\u4E2D...",
      BUY_WITH_ETH: "\u7528ETH\u8CFC\u8CB7",
      BUY_WITH_SOL: "\u7528SOL\u8CFC\u8CB7",
      BUY_WITH_CREDIT_CARD: "\u7528\u4FE1\u7528\u5361\u8CFC\u8CB7"
    },
    crossmintStatusButtonService: {
      INVALID: "\u7121\u6548\u7684clientId",
      WAITING_SUBMISSION: "\u9EDE\u64CA\u6B64\u8655\u8A2D\u7F6ECrossmint",
      PENDING: "\u60A8\u7684\u7533\u8ACB\u6B63\u5728\u5BE9\u67E5\u4E2D",
      ACCEPTED: "\u60A8\u5DF2\u6E96\u5099\u5C31\u7DD2\uFF01",
      REJECTED: "\u60A8\u7684\u7533\u8ACB\u5DF2\u88AB\u62D2\u7D55"
    }
  },
  Y = Nt;
var Pt = {
    crossmintPayButtonService: {
      CONNECTING: "Ba\u011Flan\u0131yor...",
      BUY_WITH_ETH: "ETH ile Sat\u0131n Al",
      BUY_WITH_SOL: "SOL ile Sat\u0131n Al",
      BUY_WITH_CREDIT_CARD: "Kredi Kart\u0131 ile Sat\u0131n Al"
    },
    crossmintStatusButtonService: {
      INVALID: "Ge\xE7ersiz clientId",
      WAITING_SUBMISSION: "Crossmint'i ayarlamak i\xE7in buraya t\u0131klay\u0131n",
      PENDING: "Ba\u015Fvurunuz inceleniyor",
      ACCEPTED: "\u0130\u015Flem yapmaya haz\u0131rs\u0131n\u0131z!",
      REJECTED: "Ba\u015Fvurunuz reddedildi"
    }
  },
  G = Pt;
var vt = {
    crossmintPayButtonService: {
      CONNECTING: "Verbindung wird hergestellt...",
      BUY_WITH_ETH: "Mit ETH kaufen",
      BUY_WITH_SOL: "Mit SOL kaufen",
      BUY_WITH_CREDIT_CARD: "Mit Kreditkarte kaufen"
    },
    crossmintStatusButtonService: {
      INVALID: "Ung\xFCltige clientId",
      WAITING_SUBMISSION: "Hier klicken, um Crossmint einzurichten",
      PENDING: "Ihre Anfrage wird gepr\xFCft",
      ACCEPTED: "Sie sind startklar!",
      REJECTED: "Ihre Anfrage wurde abgelehnt"
    }
  },
  V = vt;
var ht = {
    crossmintPayButtonService: {
      CONNECTING: "Conectando...",
      BUY_WITH_ETH: "Comprar con ETH",
      BUY_WITH_SOL: "Comprar con SOL",
      BUY_WITH_CREDIT_CARD: "Comprar con tarjeta de cr\xE9dito"
    },
    crossmintStatusButtonService: {
      INVALID: "clientId inv\xE1lido",
      WAITING_SUBMISSION: "Haga clic aqu\xED para configurar Crossmint",
      PENDING: "Su solicitud est\xE1 en revisi\xF3n",
      ACCEPTED: "\xA1Est\xE1 listo para usar Crossmint!",
      REJECTED: "Su solicitud fue rechazada"
    }
  },
  J = ht;
var _t = {
    crossmintPayButtonService: {
      CONNECTING: "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435...",
      BUY_WITH_ETH: "\u041A\u0443\u043F\u0438\u0442\u044C \u0437\u0430 ETH",
      BUY_WITH_SOL: "\u041A\u0443\u043F\u0438\u0442\u044C \u0437\u0430 SOL",
      BUY_WITH_CREDIT_CARD: "\u041A\u0443\u043F\u0438\u0442\u044C \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u043A\u0440\u0435\u0434\u0438\u0442\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u044B"
    },
    crossmintStatusButtonService: {
      INVALID: "\u041D\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 clientId",
      WAITING_SUBMISSION: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u0437\u0434\u0435\u0441\u044C, \u0447\u0442\u043E\u0431\u044B \u043D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C Crossmint",
      PENDING: "\u0412\u0430\u0448\u0430 \u0437\u0430\u044F\u0432\u043A\u0430 \u043D\u0430 \u0440\u0430\u0441\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u0438\u0438",
      ACCEPTED: "\u0412\u044B \u0433\u043E\u0442\u043E\u0432\u044B \u043A \u0440\u0430\u0431\u043E\u0442\u0435!",
      REJECTED: "\u0412\u0430\u0448\u0430 \u0437\u0430\u044F\u0432\u043A\u0430 \u0431\u044B\u043B\u0430 \u043E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u0430"
    }
  },
  X = _t;
var Dt = {
    crossmintPayButtonService: {
      CONNECTING: "\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043D\u044F...",
      BUY_WITH_ETH: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430 ETH",
      BUY_WITH_SOL: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430 SOL",
      BUY_WITH_CREDIT_CARD: "\u041A\u0443\u043F\u0438\u0442\u0438 \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E \u043A\u0440\u0435\u0434\u0438\u0442\u043D\u043E\u0457 \u043A\u0430\u0440\u0442\u043A\u0438"
    },
    crossmintStatusButtonService: {
      INVALID: "\u041D\u0435\u0434\u0456\u0439\u0441\u043D\u0438\u0439 clientId",
      WAITING_SUBMISSION: "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C \u0442\u0443\u0442, \u0449\u043E\u0431 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u0442\u0438 Crossmint",
      PENDING: "\u0412\u0430\u0448\u0430 \u0437\u0430\u044F\u0432\u043A\u0430 \u0440\u043E\u0437\u0433\u043B\u044F\u0434\u0430\u0454\u0442\u044C\u0441\u044F",
      ACCEPTED: "\u0412\u0438 \u0433\u043E\u0442\u043E\u0432\u0456 \u0434\u043E \u0440\u043E\u0431\u043E\u0442\u0438!",
      REJECTED: "\u0412\u0430\u0448\u0443 \u0437\u0430\u044F\u0432\u043A\u0443 \u0432\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043E"
    }
  },
  $ = Dt;
var At = {
    crossmintPayButtonService: {
      CONNECTING: "\uC5F0\uACB0 \uC911...",
      BUY_WITH_ETH: "\uC774\uB354\uB9AC\uC6C0\uC73C\uB85C \uAD6C\uB9E4",
      BUY_WITH_SOL: "\uC194\uB77C\uB098\uB85C \uAD6C\uB9E4",
      BUY_WITH_CREDIT_CARD: "\uC2E0\uC6A9\uCE74\uB4DC\uB85C \uAD6C\uB9E4"
    },
    crossmintStatusButtonService: {
      INVALID: "\uC720\uD6A8\uD558\uC9C0 \uC54A\uC740 clientId",
      WAITING_SUBMISSION: "\uC5EC\uAE30\uB97C \uD074\uB9AD\uD558\uC5EC \uD06C\uB85C\uC2A4\uBBFC\uD2B8 \uC124\uC815",
      PENDING: "\uC2E0\uCCAD\uC774 \uAC80\uD1A0 \uC911\uC785\uB2C8\uB2E4",
      ACCEPTED: "\uC774\uC81C \uC0AC\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4!",
      REJECTED: "\uC2E0\uCCAD\uC774 \uAC70\uBD80\uB418\uC5C8\uC2B5\uB2C8\uB2E4"
    }
  },
  j = At;
var Rt = {
    crossmintPayButtonService: {
      CONNECTING: "yImej...",
      BUY_WITH_ETH: "ETH vItlhutlh",
      BUY_WITH_SOL: "SOL vItlhutlh",
      BUY_WITH_CREDIT_CARD: "QelI'qam vItlhutlh"
    },
    crossmintStatusButtonService: {
      INVALID: "mIw clientId",
      WAITING_SUBMISSION: "ghItlh Crossmint vImej tlhej",
      PENDING: "Dochvam DIlmeH, vIpoQ",
      ACCEPTED: "Do' rur!",
      REJECTED: "Dochvam luHutlh"
    }
  },
  K = Rt;
var Lt = {
    crossmintPayButtonService: {
      CONNECTING: "A conectar...",
      BUY_WITH_ETH: "Comprar com ETH",
      BUY_WITH_SOL: "Comprar com SOL",
      BUY_WITH_CREDIT_CARD: "Comprar com cart\xE3o de cr\xE9dito"
    },
    crossmintStatusButtonService: {
      INVALID: "clientId inv\xE1lido",
      WAITING_SUBMISSION: "Clique aqui para configurar o Crossmint",
      PENDING: "A sua candidatura est\xE1 em an\xE1lise",
      ACCEPTED: "Est\xE1 tudo pronto!",
      REJECTED: "A sua candidatura foi rejeitada"
    }
  },
  Q = Lt;
var Ot = {
    crossmintPayButtonService: {
      CONNECTING: "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D...",
      BUY_WITH_ETH: "\u0E0B\u0E37\u0E49\u0E2D\u0E14\u0E49\u0E27\u0E22 ETH",
      BUY_WITH_SOL: "\u0E0B\u0E37\u0E49\u0E2D\u0E14\u0E49\u0E27\u0E22 SOL",
      BUY_WITH_CREDIT_CARD: "\u0E0B\u0E37\u0E49\u0E2D\u0E14\u0E49\u0E27\u0E22\u0E1A\u0E31\u0E15\u0E23\u0E40\u0E04\u0E23\u0E14\u0E34\u0E15"
    },
    crossmintStatusButtonService: {
      INVALID: "clientId \u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07",
      WAITING_SUBMISSION: "\u0E04\u0E25\u0E34\u0E01\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32 Crossmint",
      PENDING: "\u0E43\u0E1A\u0E2A\u0E21\u0E31\u0E04\u0E23\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E01\u0E33\u0E25\u0E31\u0E07\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07\u0E01\u0E32\u0E23\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A",
      ACCEPTED: "\u0E04\u0E38\u0E13\u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E41\u0E25\u0E49\u0E27!",
      REJECTED: "\u0E43\u0E1A\u0E2A\u0E21\u0E31\u0E04\u0E23\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E16\u0E39\u0E01\u0E1B\u0E0F\u0E34\u0E40\u0E2A\u0E18"
    }
  },
  z = Ot;
var Ut = {
  "en-US": A,
  "es-ES": J,
  "fr-FR": F,
  "it-IT": W,
  "ko-KR": j,
  "pt-PT": Q,
  "zh-CN": b,
  "zh-TW": Y,
  "de-DE": V,
  "ru-RU": X,
  "tr-TR": G,
  "uk-UA": $,
  "th-TH": z,
  Klingon: K
};
function I(t, e) {
  var r;
  var o = (r = Ut[e]) != null ? r : A;
  return t.split(".").reduce(function (c, n) {
    return c[n];
  }, o);
}
function Me(_ref4) {
  var t = _ref4.onClick,
    e = _ref4.connecting,
    o = _ref4.paymentMethod,
    r = _ref4.locale;
  return {
    getButtonText: function getButtonText(u) {
      if (u) return I("crossmintPayButtonService.CONNECTING", r);
      switch (o) {
        case "ETH":
          return I("crossmintPayButtonService.BUY_WITH_ETH", r);
        case "SOL":
          return I("crossmintPayButtonService.BUY_WITH_SOL", r);
        default:
          return I("crossmintPayButtonService.BUY_WITH_CREDIT_CARD", r);
      }
    },
    shouldHideButton: function shouldHideButton(_ref5) {
      var u = _ref5.hideMintOnInactiveClient,
        p = _ref5.status;
      return u && p !== "accepted";
    },
    handleClick: function handleClick(u, p) {
      t && t(u), !e && (u.defaultPrevented || p());
    }
  };
}
var Bt = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function R(t) {
  return typeof t == "string" && Bt.test(t);
}
var kt = function kt(t) {
  try {
    return R(t);
  } catch (e) {
    return console.error(e), !1;
  }
};
function Fe(_ref6) {
  var t = _ref6.libVersion,
    e = _ref6.clientId,
    o = _ref6.platformId,
    r = _ref6.auctionId,
    c = _ref6.mintConfig,
    n = _ref6.setStatus,
    m = _ref6.environment,
    u = _ref6.clientName;
  function p() {
    return _p.apply(this, arguments);
  }
  function _p() {
    _p = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var E, a, l;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(!e || e === "" || e === "<YOUR_CLIENT_ID>")) {
              _context.next = 3;
              break;
            }
            console.error("You must enter your own Crossmint client ID in <CrossmintPayButton clientId=XXX>");
            return _context.abrupt("return");
          case 3:
            if (kt(e)) {
              _context.next = 6;
              break;
            }
            console.error("The clientId passed to is invalid. Make sure to pass the clientId obtained from the crossmint team, with format XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXX");
            return _context.abrupt("return");
          case 6:
            E = d(m);
            _context.next = 9;
            return fetch("".concat(E, "/api/crossmint/onboardingRequests/").concat(e, "/status"), {
              headers: _defineProperty(_defineProperty({}, "X-Client-Version", t), "X-Client-Name", u)
            });
          case 9:
            a = _context.sent;
            if (!(a.status === 200)) {
              _context.next = 17;
              break;
            }
            _context.next = 13;
            return a.json();
          case 13:
            l = _context.sent;
            n(l.status);
            _context.next = 18;
            break;
          case 17:
            n("invalid");
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _p.apply(this, arguments);
  }
  var f = function f() {
      var E = d(m);
      window.open("".concat(E, "/developers/onboarding?").concat(C()), "_blank");
    },
    C = function C() {
      var E = {
        clientId: e
      };
      return o && (E.platformId = o), r && (E.auctionId = r), c && (E.mintConfig = JSON.stringify(c)), new URLSearchParams(E).toString();
    };
  return {
    fetchClientIntegration: p,
    goToOnboarding: f
  };
}
function Ve(_ref7) {
  var t = _ref7.onClick,
    e = _ref7.locale;
  return {
    getButtonText: function getButtonText(n) {
      switch (n) {
        case "invalid":
          return I("crossmintStatusButtonService.INVALID", e);
        case "waiting-submission":
          return I("crossmintStatusButtonService.WAITING_SUBMISSION", e);
        case "pending":
          return I("crossmintStatusButtonService.PENDING", e);
        case "accepted":
          return I("crossmintStatusButtonService.ACCEPTED", e);
        case "rejected":
          return I("crossmintStatusButtonService.REJECTED", e);
      }
    },
    isButtonDisabled: function isButtonDisabled(n) {
      return n !== "waiting-submission";
    },
    handleClick: function handleClick(n, m, u) {
      t && t(n), m === "waiting-submission" && u();
    }
  };
}
function Ke(_ref8) {
  var t = _ref8.clientId,
    e = _ref8.uiConfig,
    o = _ref8.recipient,
    r = _ref8.environment,
    c = _ref8.mintConfig,
    n = _ref8.locale,
    m = _ref8.whPassThroughArgs;
  var u = d(r);
  function p() {
    var E = new URLSearchParams({
      clientId: t
    });
    return e != null && E.append("uiConfig", JSON.stringify(e)), o != null && E.append("recipient", JSON.stringify(o)), c != null && E.append("mintConfig", JSON.stringify(c)), n != null && E.append("locale", n), m != null && E.append("whPassThroughArgs", JSON.stringify(m)), "".concat(u, "/sdk/paymentElement?").concat(E.toString());
  }
  function f(E) {
    function a(l) {
      l.origin === u && Object.values(N).includes(l.data.type) && E(l);
    }
    return window.addEventListener("message", a), function () {
      window.removeEventListener("message", a);
    };
  }
  function C(E) {
    var l;
    var a = document.getElementById("iframe-crossmint-payment-element");
    (l = a == null ? void 0 : a.contentWindow) == null || l.postMessage({
      type: x.PARAMS_UPDATE,
      payload: E
    }, u);
  }
  return {
    getIframeUrl: p,
    listenToEvents: f,
    emitQueryParams: C
  };
}
import { backOff as xt } from "exponential-backoff";
function nn() {
  var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    t = _ref9.environment;
  function e(_ref10, c) {
    var r = _ref10.orderIdentifier;
    var n = [],
      m = [],
      u = [];
    function p(a) {
      c(a), n.push(a.type), a.type === N.ORDER_PROCESS_FINISHED && clearInterval(E);
    }
    function f(a) {
      if (!!a.payload.transactionIdentifier) {
        if (a.type === N.TRANSACTION_FULFILLMENT_SUCCEEDED) {
          if (m.includes(a.payload.transactionIdentifier)) return;
          m.push(a.payload.transactionIdentifier), p(a);
        } else if (a.type === N.TRANSACTION_FULFILLMENT_FAILED) {
          if (u.includes(a.payload.transactionIdentifier)) return;
          u.push(a.payload.transactionIdentifier), p(a);
        }
      }
    }
    var C = !1,
      E = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var a, _iterator, _step, l;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!C) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              C = !0;
              _context2.next = 5;
              return o({
                orderIdentifier: r
              });
            case 5:
              a = _context2.sent;
              _iterator = _createForOfIteratorHelper(a);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  l = _step.value;
                  n.includes(l.type) ? f(l) : p(l);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              C = !1;
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      })), 5e3);
    window.onpopstate = function () {
      C = !1, clearInterval(E);
    };
  }
  function o(_x) {
    return _o.apply(this, arguments);
  }
  function _o() {
    _o = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(_ref12) {
      var r;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            r = _ref12.orderIdentifier;
            _context4.next = 3;
            return xt( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
              var n;
              return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return fetch("".concat(d(t), "/api/sdk/orders/").concat(r, "/status"), {
                      method: "GET",
                      headers: {}
                    });
                  case 2:
                    _context3.next = 4;
                    return _context3.sent.json();
                  case 4:
                    n = _context3.sent;
                    return _context3.abrupt("return", n.error ? [] : n);
                  case 6:
                  case "end":
                    return _context3.stop();
                }
              }, _callee3);
            })), {
              startingDelay: 650,
              timeMultiple: 2.5,
              numOfAttempts: 5
            });
          case 3:
            return _context4.abrupt("return", _context4.sent);
          case 4:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return _o.apply(this, arguments);
  }
  return {
    listenToMintingEvents: e
  };
}
function an() {
  var _ref14 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    t = _ref14.environment;
  var e = d(t);
  function o(r) {
    function c(n) {
      n.origin === e && Object.values(M).includes(n.data.type) && r(n);
    }
    return window.addEventListener("message", c), function () {
      window.removeEventListener("message", c);
    };
  }
  return {
    listenToEvents: o
  };
}
export { Vt as ALL_CHAINS, Zt as CheckoutErrorEvents, N as CheckoutEvents, ct as CheckoutOrderEvents, B as CheckoutPaymentErrorEvents, at as CheckoutPaymentEvents, Et as CheckoutQuoteEvents, ut as CheckoutRecipientEvents, k as CheckoutTransactionErrorEvents, mt as CheckoutTransactionEvents, ee as CrossmintErrors, tt as EVM_CHAINS, x as PaymentElementSDKEvents, pt as PaymentErrors, zt as PaymentMethodType, M as UiEvents, Ft as assertValidNFTCollectionViewProps, Yt as assertValidValidateNFTDetailProps, nt as baseUrls, et as clientNames, oe as crossmintModalService, Me as crossmintPayButtonService, Ke as crossmintPaymentService, Ve as crossmintStatusButtonService, Fe as crossmintStatusService, an as crossmintUiService, rt as customHeaders, bt as generateClientId, d as getEnvironmentBaseUrl, jt as getNFTCollectionViewSrc, Kt as getNFTDetailSrc, ot as mintingContractTypes, it as onboardingRequestStatusResponse, Jt as paymentMethodIsEth, Xt as paymentMethodIsSol, nn as useCrossmintEvents };